import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  code?: SugarmateError["code"];
}

const polyglotPrefix = "toasts.accept_invitation_error."

export function AcceptInvitationErrorToast(props: Props) {
  const {
    id, code,
  } = props

  const polyglot = usePolyglot()
  const body = useMemo(
    () => {
      switch (code) {
        case 1001:
          return polyglot.t(`${polyglotPrefix}max_follows_body`)
        case 1004:
          return polyglot.t(`${polyglotPrefix}country_mismatch_body`)
        case 1005:
          return polyglot.t(`${polyglotPrefix}already_exists_body`)
        case 422:
          return polyglot.t(`${polyglotPrefix}invalid_email_body`)
        default:
          return polyglot.t(`${polyglotPrefix}generic_error_body`)
      }
    },
    [
      code,
      polyglot,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
    />
  )
}
